import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { JssModule, TextField } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'essent-order-overview-expected-cost',
  templateUrl: './order-overview-expected-cost.component.html',
  styleUrls: [
    './order-overview-expected-cost.component.ed.scss',
    './order-overview-expected-cost.component.essent.scss',
  ],
  standalone: true,
  imports: [CommonModule, JssModule],
})
export class OrderOverviewExpectedCostComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() monthLabel?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() monthlyAmount? = 0;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() beforeDiscountMonthLabel?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() beforeDiscountMonthlyAmount? = 0;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rearrangeColumns = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() hasDiscount = false;
}
